/**
 * Phase 3 - Turkish translations module
 */
import enBase from './en.js';
import { translationsTr } from '../../utils/translations/translations.tr.js';
import { plansTranslationsTr } from '../../utils/translations/plans/plansTranslations.tr.js';

const merged = { ...enBase, ...translationsTr, ...plansTranslationsTr };
export default merged;
